"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var effects_1 = require("redux-saga/effects");
var create_saga_1 = require("./create-saga");
var spark_1 = require("./spark");
var utils_1 = require("./utils");
;
;
;
;
;
;
var Reducer = /** @class */ (function () {
    /**
     * Creates Reducer class and registers it in the spark.
     *
     * @param name - name of the reducer.
     * @param initialState - reducer's initial state.
     */
    function Reducer(name, initialState) {
        if (initialState === void 0) { initialState = {}; }
        this.actionHandlers = {};
        this.actionCreators = {};
        this.sagas = [];
        spark_1["default"].registerReducer(name, this);
        this.initialState = initialState;
    }
    // -------- PUBLIC INTERFACE
    /**
     * Adds synchronous action.
     * Generates action type and action creator.
     *
     * @param actionName - action name, it will be used for generating action type and as action creator name.
     * @param handler - handler function.
     *
     * @return Action creator function.
     */
    Reducer.prototype.addAction = function (actionName, handler) {
        var actionType = utils_1.camel2const(actionName);
        this.actionHandlers[actionType] = handler;
        return this.addActionCreator(actionName, actionType);
    };
    /**
     * Adds asynchronous action with three states start/error/success.
     * Generates action types, action creators and sagas.
     *
     * @param actionName - action name, it will be used for generating action type and as action creator name.
     * @param asyncMethod - async function which will used in saga (has to return promise).
     * @param handlers - map with start/error/success handler functions.
     * @param effect - custom saga effect, default: takeLatest
     *
     * @return Action creator function.
     */
    Reducer.prototype.addAsyncAction = function (actionName, asyncMethod, handlers, sagaOptions) {
        var _this = this;
        if (sagaOptions === void 0) { sagaOptions = {}; }
        var actionTypeBody = utils_1.camel2const(actionName);
        var actions = ['start', 'error', 'success'];
        var actionTypes = {
            start: actionTypeBody + "_START",
            error: actionTypeBody + "_ERROR",
            success: actionTypeBody + "_SUCCESS"
        };
        var sagaEffect = sagaOptions.effect || effects_1.takeLatest;
        var saga = sagaOptions.sagaCreator ?
            // User defined saga
            sagaOptions.sagaCreator(asyncMethod, actionTypes) :
            // Create saga if user didn't pass it
            create_saga_1["default"](asyncMethod, actionTypes, sagaEffect);
        this.sagas.push(saga);
        // Action creator
        var actionCreator = this.addActionCreator(actionName, actionTypes.start);
        // Action types
        // [ACTION_NAME]_START
        // [ACTION_NAME]_ERROR
        // [ACTION_NAME]_SUCCESS
        actions.forEach(function (currentActionName) {
            var actionType = actionTypes[currentActionName];
            _this.actionHandlers[actionType] = handlers[currentActionName];
        });
        return actionCreator;
    };
    // -------- PUBLIC METHODS
    // -------- INTENDED FOR INTERNAL USE ONLY
    /**
     * Returns reducer function.
     *
     * @return Reducer function with using handlers map.
     */
    Reducer.prototype.getReducerFunction = function () {
        var _this = this;
        return function (state, action) {
            if (state === void 0) { state = _this.initialState; }
            if (action === void 0) { action = {}; }
            var actionHandler = _this.actionHandlers[action.type];
            return actionHandler ? actionHandler(state, action) : state;
        };
    };
    /**
     * CAUTION! Intended for internal use only.
     * Gets all of the generated sagas.
     *
     * @return Array of all generated sagas.
     */
    Reducer.prototype.getSagas = function () {
        return this.sagas;
    };
    /**
     * CAUTION! Intended for internal use only (testing).
     * Gets map of action handlers
     *
     * @return Map of action handlers.
     */
    Reducer.prototype.getActionHandlers = function () {
        return this.actionHandlers;
    };
    // -------- PRIVATE METHODS
    /**
     * Based on the action name and action creates generic action creator function,
     * and registers it internally.
     *
     * @param actionName - Action name (ie. getUsers)
     * @param actionType - Action type (ie. GET_USERS)
     *
     * @return Action creator function.
     */
    Reducer.prototype.addActionCreator = function (actionName, actionType) {
        var actionCreator = function (params) { return (__assign({ type: actionType }, params)); };
        this.actionCreators[actionName] = actionCreator;
        return actionCreator;
    };
    return Reducer;
}());
exports["default"] = Reducer;
